<reset-password-translations></reset-password-translations>
<div class="row">
  <div class="col-7 col-sm-12">
    <div class="login-block">
      <h1 i18n="reset password title@@reset.password.title">Reset password</h1>
      <p i18n="reset password description@@reset.password.description">Create a new password</p>

      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit(resetPasswordForm.value)">
        <div class="form-row">
          <label class="form-label"
            for="password"
            i18n="password label@@login.form.password">
						Password
					</label>

          <div class="form-input-container">
            <input [formControl]="resetPasswordForm.controls['password']"
              attr.type="{{passwordFieldType}}"
              id="password"
              name="password"
              required
              title="Please enter a password" />

            <button class="form-show-password"
              type="button"
              (click)="togglePassword()">

              <svg class="icon-eye" width="18" height="13" viewBox="0 0 18 13">
                <use xlink:href="/images/icons/svg-sprite.svg#eye"></use>
              </svg>
            </button>

            @if (!resetPasswordForm.controls['password'].valid
              && resetPasswordForm.controls['password'].touched) {
              <p
                class="form-input-error"
                i18n="Error: enter a password@@reset.password.error.password.empty">
							Please enter a password
						</p>
            }
          </div>
        </div>

        <div class="form-row">
          <label class="form-label"
            for="confirmpassword"
            i18n="confirm password label@@reset.password.form.confirm.password">
						Confirm password
					</label>

          <div class="form-input-container">
            <input [formControl]="resetPasswordForm.controls['confirmpassword']"
              attr.type="{{passwordFieldType}}"
              id="confirmpassword"
              name="confirmpassword"
              required
              title="Please enter a password" />

            @if (!resetPasswordForm.controls['confirmpassword'].valid) {
              @if (resetPasswordForm.controls['confirmpassword'].touched
                && resetPasswordForm.controls['confirmpassword'].hasError('required')) {
                <p
                  class="form-input-error"
                  i18n="Error: enter a password@@reset.password.error.confirm.password.empty">
								Please confirm your password
							</p>
              }
              @if (resetPasswordForm.controls['confirmpassword'].touched
                && resetPasswordForm.controls['confirmpassword'].hasError('MatchPassword')
                && !resetPasswordForm.controls['confirmpassword'].hasError('required')) {
                <p
                  class="form-input-error"
                  i18n="Error: enter a password@@reset.password.error.confirm.password.match">
								Passwords do not match
							</p>
              }
            }
          </div>
        </div>

        @if (formError) {
          <div class="form-row">
            <div class="form-input-container">
              <p class="form-input-error">{{formError}}</p>
            </div>
          </div>
        }

        <div class="button-bar button-bar--password">
          <button [disabled]="!resetPasswordForm.valid"
            class="button theme-btn-secondary"
            i18n="Reset password@@reset.password.form.button"
            type="submit">
						Reset password
					</button>
        </div>
      </form>
    </div>
  </div>
</div>
